import { GET_MANAGMENT_API } from '../utils/api';

export const LOAD_MANAGMENT_REQUEST = '@managment/LOAD_MANAGMENT_REQUEST';
export const RESET_MANAGMENT_REQUEST = '@managment/RESET_MANAGMENT_REQUEST';
export type MANAGMENT_REQUEST = typeof LOAD_MANAGMENT_REQUEST;
export type RESET_REQUEST = typeof RESET_MANAGMENT_REQUEST;


export interface LoadManagment {
  type: MANAGMENT_REQUEST;
  payload: {
    managment: null,
  }
}

export interface zeroManagment {
  type: RESET_REQUEST;
  payload: {
    managment: null,
  }
}


export async function loadManagment(body: any): Promise<LoadManagment> {
  try {
    const response = await GET_MANAGMENT_API(body);
    return {
      type: LOAD_MANAGMENT_REQUEST,
      payload: {
        managment: response.data
      }
    };
  } catch (error) {
    return { 
      type: LOAD_MANAGMENT_REQUEST, 
      payload: {
        managment: Object(error)
      }
    }
  }
}

export function resetManagment(): zeroManagment {
  return {
    type: RESET_MANAGMENT_REQUEST,
    payload: {
      managment: null
    }
  }
}
